import "core-js/modules/es.array.concat.js";
import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/company");
export var getCompanyData = function getCompanyData(eik) {
  return getReq("".concat(BASE_URL, "/search?identifier=").concat(eik));
};